import React, { useState } from 'react';
import { Clock3, LogOut, RefreshCw } from 'lucide-react';
import { axiosInstance } from '../App';

export default function PendingApproval({ user, setUser }) {
  const [checking, setChecking] = useState(false);

  const refresh = async () => {
    setChecking(true);
    try {
      const { data } = await axiosInstance.get('/auth/me');
      setUser(data);
    } finally {
      setChecking(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-12" data-testid="pending-organization-approval">
      <div className="mx-auto max-w-lg text-center">
        <div className="text-4xl font-bold bg-gradient-to-r from-sky-600 to-indigo-600 bg-clip-text text-transparent">Qflow</div>
        <section className="mt-10 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-600"><Clock3 size={28} /></div>
          <h1 className="mt-5 text-2xl font-semibold text-slate-950">Organization approval pending</h1>
          <p className="mt-3 text-slate-600">
            Your request for <strong>{user?.organization_name || 'this organization'}</strong> has been sent to Qflow Platform Operations.
            The platform will remain locked until a Qflow administrator approves the organization and assigns your access level.
          </p>
          <p className="mt-3 text-sm text-slate-500">You can safely return later. Your request and account have been saved.</p>
          <div className="mt-7 flex justify-center gap-3">
            <button onClick={refresh} disabled={checking} className="inline-flex items-center gap-2 rounded-lg bg-sky-600 px-4 py-2.5 text-sm font-medium text-white disabled:opacity-60">
              <RefreshCw size={16} className={checking ? 'animate-spin' : ''} /> Check status
            </button>
            <button onClick={logout} className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-700">
              <LogOut size={16} /> Sign out
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
